import React from "react";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router";

interface BreadcrumbProps {
  parent: string;
  parentTo: string;
  /** Optional current page name. When omitted, only the parent link is shown. */
  current?: React.ReactNode;
  /** Optional badge rendered inline next to the current page name. */
  badge?: React.ReactNode;
  actions?: React.ReactNode;
}

export function Breadcrumb({
  parent,
  parentTo,
  current,
  badge,
  actions,
}: BreadcrumbProps) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-2 min-w-0">
        <button
          onClick={() => navigate(parentTo)}
          className="flex items-center gap-1.5 text-sm hover:text-foreground transition-colors"
        >
          <ArrowLeft className="size-3.5" />
          {parent}
        </button>
        {current != null && current !== "" && current !== false && (
          <>
            <ChevronRight className="size-3.5 text-muted-foreground flex-shrink-0" />
            {typeof current === "string" ? (
              <span className="text-sm font-semibold truncate">{current}</span>
            ) : (
              <span className="min-w-0 truncate">{current}</span>
            )}
          </>
        )}
        {badge && <span className="flex-shrink-0">{badge}</span>}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>
      )}
    </div>
  );
}
